import React, { useEffect } from 'react';
import OrdersTable from './OrdersTable';
import { useSelector, useDispatch } from 'react-redux';
import { TRootState } from 'redux/reducers/rootReducer';
import useStatusDynamic from 'hooks/useStatusDynamic';
import EStatusAPIKeys from 'types/backend_models/lookup_status/EStatusAPIKeys';
import useCombinedRequestStatus from 'hooks/useCombinedRequestStatus';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { fetchOrders, initialQueryData } from 'redux/actions/dataActions/orders/ordersDataActions';
import RequestStatus from 'types/general/requests/RequestStatus';
import IStatusModel from 'types/backend_models/lookup_status/IStatusModel';
import { LargeLoadingIndicator } from 'components/content/shared/other/LoadingIndicator';
import { ResetScroll } from 'functions/General';
import { LargeErrorMessage } from 'components/content/shared/other/ErrorMessage';
import { useSearchTableQuery } from 'hooks/urlHooks';
import { combineTableQueryData } from 'functions/tables/TableFunctions';
import { resetOrdersFetchStatus } from 'redux/reducers/data_action_reducers/orders/ordersDataReducer';

var setupCompleted = false;

function OrdersOverviewPage()
{
	const dispatch = useDispatch();
	const thunkDispatch = useThunkDispatch();
	const ordersState = useSelector((rootState: TRootState) => rootState.data.orders.orders);
	const orderStatusState = useStatusDynamic(EStatusAPIKeys.orderStatuses);
	const combinedRequestStatus = useCombinedRequestStatus(ordersState, orderStatusState);
	const { updateSearchByTableQuery, getTableQueryFromSearch } = useSearchTableQuery();

	// Initialization call
	useEffect(() =>
	{
		ResetScroll();
		const searchQuery = getTableQueryFromSearch();
		const queryData = combineTableQueryData(searchQuery, initialQueryData);


		// Update url search
		updateSearchByTableQuery(queryData);
		// Send fetch request
		thunkDispatch(fetchOrders(queryData));
		// console.log('TrippleDataFetch: Initialization')

		return function cleanup()
		{
			// Reset request status
			dispatch(resetOrdersFetchStatus());
			setupCompleted = false;
		}

		// eslint-disable-next-line
	}, []);

	if (combinedRequestStatus.requestStatus === RequestStatus.succes) {
		setupCompleted = true;
	}


	return (
		<div className="orders-overview-page">
			{
				setupCompleted &&
				<>
					<h1 className="page-title mgb-5">Your Orders</h1>
					<h3 className="page-subtitle mgb-25">An overview of your APTEC orders and related documents, such as your order, order confirmation,…</h3>
					<OrdersTable
						ordersState={ordersState}
						orderStatusses={orderStatusState.data as IStatusModel[]}
					/>
				</>
			}
			{
				!setupCompleted &&
				<LargeLoadingIndicator />
			}
			{
				combinedRequestStatus.requestStatus === RequestStatus.error &&
				<LargeErrorMessage />
			}
		</div>
	);
};

export default OrdersOverviewPage;